import { isValid } from 'date-fns';
import { DateRange } from 'react-day-picker';

import { normalizeNullableToStartOfDayUTC } from '@/utils/date-formatters/date-formatters';

export const stringToDateRange = (
  value: string | null | undefined,
  dateRangeSeparator = ':'
): DateRange | null => {
  if (!value) return null;

  const separatorIndex = value.indexOf(dateRangeSeparator);

  if (separatorIndex === -1) {
    return null;
  }

  const start = value.slice(0, separatorIndex);
  const end = value.slice(separatorIndex + dateRangeSeparator.length);
  if (!start || !end) {
    return null;
  }

  const startDate = new Date(start);
  const endDate = new Date(end);

  if (!isValid(startDate) || !isValid(endDate)) return null;

  return {
    from: normalizeNullableToStartOfDayUTC(startDate) ?? undefined,
    to: normalizeNullableToStartOfDayUTC(endDate) ?? undefined,
  };
};

/* Example usage
  const formatDate = date =>
    formatDateLib(date, { month: 'short', day: 'numeric', year: 'numeric' });

  const dateRangeToString = createDateRangeToStringFormatter(formatDate);

  const label = dateRangeToString(option.value)
*/
export const createDateRangeToStringFormatter =
  (format: (date: Date) => string) =>
  ({ from, to }: DateRange): string =>
    from && to ? `${format(from)}:${format(to)}` : '';
